import { render } from "./SimulationRecommendationSelection.vue?vue&type=template&id=ea305b16&scoped=true"
import script from "./SimulationRecommendationSelection.vue?vue&type=script&lang=js"
export * from "./SimulationRecommendationSelection.vue?vue&type=script&lang=js"

import "./SimulationRecommendationSelection.vue?vue&type=style&index=0&id=ea305b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea305b16"]])

export default __exports__